import React, {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import { Checkbox } from "@chakra-ui/react";
import { FiEdit3 } from "react-icons/fi";
import { TaskContent } from "./TaskContent";
import { TaskEvent } from "./TaskEvent";
import { TaskWrapper } from "./TaskWrapper";
import { useFlash, useTask } from "./utils";

export const TaskGroupContext = createContext({ isGroup: false });

type TaskProps = {
  children: ReactNode;
  taskId: string;
  title?: string;
};

export function Task({ children, taskId, title = "Task!" }: TaskProps) {
  const { isGroup } = useContext(TaskGroupContext);
  const { isTaskComplete, saveTask, savingTask } = useTask(taskId);

  const [checked, setChecked] = useState(isTaskComplete);

  const flash = useFlash();

  useEffect(() => {
    setChecked(isTaskComplete);
  }, [isTaskComplete]);

  const content = (
    <>
      <Checkbox
        isDisabled={savingTask}
        isChecked={checked}
        onChange={({ target: { checked } }) => {
          setChecked(checked);
          saveTask(checked ? new Date() : null);
          window.gtag?.("event", checked ? "task_complete" : "task_uncheck");
        }}
        colorScheme={checked ? "green" : "indigo"}
        textDecor={checked ? "line-through" : undefined}
      >
        <TaskContent>{children}</TaskContent>
      </Checkbox>
      <TaskEvent taskId={taskId} isComplete={checked} />
    </>
  );

  return isGroup ? (
    content
  ) : (
    <TaskWrapper
      taskId={taskId}
      isComplete={checked}
      icon={FiEdit3}
      title={title}
      {...flash}
    >
      {content}
    </TaskWrapper>
  );
}
